module.exports = __webpack_public_path__ + "static/media/point-5.449850c2.png";